export const formatPrice = (price) => {
    let formattedPrice = new Intl.NumberFormat('pl-PL', {
        style: 'currency',
        currency: 'PLN',
    }).format(price);

    formattedPrice = formattedPrice.replace(',00', '');

    return formattedPrice;
};
